(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('corner-related-products')) {
  customElements.define('corner-related-products', class extends HTMLElement {
    connectedCallback() { if (!this.loaded) this.load(); }
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.controller = new AbortController();
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('corner-related-products');
        if (content && this.isConnected) {
          this.innerHTML = content.innerHTML;
          this.loaded = true;
        }
      } catch (error) {
        this.loaded = false;
      } finally {
        this.loading = false;
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
